import { render, staticRenderFns } from "./mainlandorder-list.vue?vue&type=template&id=433e0e5c&"
import script from "./mainlandorder-list.vue?vue&type=script&lang=ts&"
export * from "./mainlandorder-list.vue?vue&type=script&lang=ts&"
import style0 from "./mainlandorder-list.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports